import { EmailDeliveryGroupByEnum } from '../../../generated/internal.graphql';

/**
 * The dimension the summary rollup is grouped by, keyed off the generated
 * `EmailDeliveryGroupByEnum`.
 *
 * This one is an *argument* rather than a read field: the summary query requires it, so the map
 * exists so a caller passes a checked constant instead of a string literal the backend would reject
 * at query time.
 */
export const EmailDeliveryGroupBy = Object.freeze({
  RECIPIENT_DOMAIN: EmailDeliveryGroupByEnum.RecipientDomain,
  ACCOUNT: EmailDeliveryGroupByEnum.Account,
  MAIL_STREAM: EmailDeliveryGroupByEnum.MailStream,
});
export type EmailDeliveryGroupBy = (typeof EmailDeliveryGroupBy)[keyof typeof EmailDeliveryGroupBy];
